import React from 'react'
import styled from 'styled-components'
import {typography} from '../styles'

const P = styled.div`
  ${typography.lh14.normal}
  margin-top: 1rem;
  width: 100%;
  strong {
    ${typography.bold}
  }
  small {
    font-size: 0.8em;
  }
  pre {
    display: inline;
  }
`

export default ({children}) => (
  <P>{children}</P>
)



/** WEBPACK FOOTER **
 ** ./src/components/P.js
 **/